export const managerMisc = {
  // Shared field / label strings reused across the advisor and user views
  fields: {
    name: "Vorname",
    lastname: "Nachname",
    email: "E-Mail-Adresse",
    idNumber: "Ausweisnummer",
    phone: "Telefon",
  },
  // src/views/Manager/pagos/index.vue
  pagos: {
    title: "Zahlungsrechnungen",
    subtitle: "Liste der von Nutzern getätigten Zahlungen",
    emailUser: "E-Mail des Nutzers",
    value: "Betrag",
    issueDate: "Ausstellungsdatum",
    status: "Status",
    downloadInvoice: "Rechnung herunterladen",
    generatingInvoice: "Rechnung wird erstellt ...",
    almostDone: "Fast fertig, bitte warten ...",
    loading: "Wird geladen ...",
    invoiceError: "Die Rechnung konnte leider nicht erstellt werden",
  },
  // src/views/Manager/advisors/* and src/components/manager/advisors/*
  advisors: {
    title: "Plattform-Berater",
    subtitle: "Liste der Berater.",
    createNew: "Neu anlegen",
    thId: "ID",
    thRefCode: "Ref.-Code",
    thEmail: "E-Mail",
    thRegisterDate: "Registrierungsdatum",
    deleteConfirmMsg: "Möchten Sie diesen Berater wirklich löschen?",
    deleteConfirmHeader: "Bestätigen",
    menuUpdateInfo: "Informationen aktualisieren",
    menuAffiliatesList: "Liste der Partner",
    menuDelete: "Löschen",
    createTitle: "Neuen Berater anlegen",
    savingInfo: "Informationen werden gespeichert...",
    saveAdvisor: "Berater speichern",
    updateTitle: "Beraterdaten aktualisieren",
    updatingInfo: "Informationen werden aktualisiert...",
    updateAdvisor: "Berater aktualisieren",
    cancel: "Abbrechen",
  },
  // src/components/manager/advisors/modalListAffiliates.vue
  affiliates: {
    listTitle: "Liste der Partner",
    emptyPre: "Keine Nutzer sind mit dem Code verknüpft",
  },
  // src/components/manager/users/menuRoutes.vue
  menu: {
    checkinsDone: "Abgeschlossene Check-ins",
    checkinsPending: "Ausstehende Check-ins",
    checkinsScheduled: "Geplante Check-ins",
    logoAndName: "Logo und Name der Unterkunft",
    welcomeMessage: "Willkommensnachricht",
    policies: "Unterkunftsrichtlinien",
    roomKeys: "Zimmerschlüssel",
    authorities: "Behörden",
    guestReviews: "Gästebewertungen",
  },
  // src/components/manager/users/accommodations.vue
  accommodations: {
    createdDate: "Erstellungsdatum",
    checkins: "Check-ins",
  },
  // src/views/Manager/index.vue
  dashboard: {
    title: "Admin-Bereich",
    subtitle: "Liste der Plattformstatistiken",
    registeredUsers: "Registrierte Nutzer",
    viewList: "Liste ansehen",
    propertiesCreated: "Erstellte Unterkünfte",
    checkinsDone: "Abgeschlossene Check-ins",
  },
};